import uniqWith from 'lodash.uniqwith';
import { anythingToString } from '@hawkins/helpers';
import { checkDropdownOptionsDeepEqual, checkDropdownOptionsReferentiallyEqual } from './dropdownEqualityChecks';
/**
 * By sorting an object's keys (nested keys included when applicable), we can be sure that turning the sorted object
 * into a string will result in a repeatable hash key for the hash map in dedupeOptions.
 */
function getObjectWithSortedKeys(opt) {
    if (!opt) {
        return {};
    }
    var sortedOptionKeys = Object.keys(opt).sort();
    return sortedOptionKeys.reduce(function (acc, objectKey) {
        var originalValue = opt[objectKey];
        // @ts-ignore (we know the shape will conform, but TS doesn't like indexing this way)
        acc[objectKey] = typeof originalValue === 'object' ? getObjectWithSortedKeys(originalValue) : originalValue;
        return acc;
    }, {});
}
/**
 * Deduplicates options using checkOptionsEqual. Any duplicates seen will be tossed (the first instance of something
 * that has a duplicate will get priority)
 */
export function dedupeOptions(opts, checkOptionsEqual) {
    // If checkOptionsEqual is either of these two out-of-the-box options equality functions, then we can take the
    // most performant route and doing some convenient hashing and converting to an array to dedupe the options.
    if (checkOptionsEqual === checkDropdownOptionsDeepEqual ||
        checkOptionsEqual === checkDropdownOptionsReferentiallyEqual) {
        var hashedOptions = new Map(opts.map(function (opt) { return [
            checkOptionsEqual === checkDropdownOptionsDeepEqual ? anythingToString(getObjectWithSortedKeys(opt)) : opt,
            opt,
        ]; }));
        return Array.from(hashedOptions.values());
    }
    // Reaching this point means we can't conveniently use Array.from & Map to hash the options in a way that can be reliably
    // retrieved from the hash using checkRawValuesEqual's expectations (since those expectations are unknown). Take a less
    // performant route and use uniqWith to check "equality" by checkOptionsEqual's expectations.
    return uniqWith(opts, checkOptionsEqual);
}
